import type { RouteRecordRaw } from 'vue-router'
import { routeNames, routePaths } from '@/router/router-constants'

export const toolRunsRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.toolRuns,
    name: routeNames.toolRuns,
    component: () => import('@/pages/tool-runs/ToolRunsView.vue'),
    meta: {
      permission: 'tool-runs.read.assigned',
      icon: 'pi pi-cog',
      labelKey: 'toolRuns',
      featureFlag: 'tool-runs',
    },
  },
  {
    path: routePaths.toolRunCreation,
    name: routeNames.toolRunCreation,
    component: () => import('@/pages/tool-runs/AddToolRunView.vue'),
    meta: {
      permission: 'tool-runs.write.all',
      labelKey: 'new_f',
      rootRouteName: routeNames.toolRuns,
    },
  },
  {
    path: routePaths.toolRunDetails,
    name: routeNames.toolRunDetails,
    component: () => import('@/pages/tool-runs/ToolRunDetailsView.vue'),
    meta: {
      permission: 'tool-runs.read.assigned',
      labelKey: 'toolRuns',
      rootRouteName: routeNames.toolRuns,
    },
  },
]
